export default __webpack_public_path__ + "static/media/img_hr-2.88fadd48.png";